import lazyLoading from './lazyLoading'

export default {
  name: 'test',
  meta: {
    expanded: false,
    title: 'Pruebas',
    iconClass: 'fa fa-money'
  },
  children: [
    {
      name: 'reporte-deudas-personas',
      path: '/reporte-deudas-personas',
      component: lazyLoading('app/ReporteDeudasPersonas'),
      meta: {
        title: 'Reporte Deudas Personas',
        requiresAuth: true
      }
    },
    {
      name: 'UnfinishTravel',
      path: '/unfinishTravel',
      component: lazyLoading('app/UnfinishTravelList'),
      meta: {
        title: 'Vienes Sin Terminar',
        requiresAuth: true
      }
    },
    {
      name: 'ReviewList',
      path: '/reviews',
      component: lazyLoading('app/reviews/ReviewList'),
      meta: {
        title: 'Calificaciones',
        requiresAuth: true
      }
    },
    {
      name: 'PromoList',
      path: '/promos',
      component: lazyLoading('app/promos/PromoList'),
      meta: {
        title: 'Códigos Promociones',
        requiresAuth: true
      }
    },
    {
      name: 'InvoiceList',
      path: '/invoices',
      component: lazyLoading('app/invoices/InvoiceList'),
      meta: {
        title: 'Facturas Emitidas',
        requiresAuth: true
      }
    },
    {
      name: 'sales',
      path: '/sales',
      component: lazyLoading('app/sales/List'),
      meta: {
        title: 'Ventas',
        requiresAuth: true
      }
    },
    /*
    {
      path: '/financial/aircab-sales',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Aircab Venta'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/AircabList'),
          meta: {
            title: 'Lista Aircab'
          }
        }
      ]
    },
    {
      path: '/financial/aircab-scheduled-sales',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Aircab Vuelta Venta'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/AircabScheduledList'),
          meta: {
            title: 'Lista Vuelta Aircab'
          }
        }
      ]
    },
    {
      path: '/financial/ticket-scheduled',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Ticket Retorno Asignados'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/TicketScheduledList'),
          meta: {
            title: 'Ticket Retorno Asignados'
          }
        }
      ]
    },
    {
      path: '/financial/daily-sales',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Ventas del Día'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/DailySalesList'),
          meta: {
            title: 'Ventas del Día'
          }
        },
        {
          path: ':dailySaleId',
          component: lazyLoading('financial/DailySalesDetail'),
          props: true,
          meta: {
            title: 'Detalle del venta del día'
          }
        }
      ]
    },
    */
    {
      name: 'financialDeposits',
      path: '/financial/deposits',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Pagos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/DepositList'),
          meta: {
            title: 'Pagos'
          }
        },
        {
          name: 'depositDetail',
          path: ':depositId',
          component: lazyLoading('financial/DepositDetail'),
          props: true,
          meta: {
            title: 'Detalle del Pago'
          }
        }
      ]
    },
    {
      name: 'clarificationTicket',
      path: '/utils/clarification-ticket',
      component: lazyLoading('tools/AssignTicket'),
      meta: {
        title: 'Aclaración de Boletos',
        requiresAuth: true
      }
    },
    {
      name: 'processDay',
      path: '/utils/process-day',
      component: lazyLoading('tools/ProcessDay'),
      meta: {
        title: 'Proceso del Día',
        requiresAuth: true
      }
    },
    {
      name: 'testDebits',
      path: '/debits',
      component: lazyLoading('app/debits/Main'),
      meta: {
        title: 'Adeudos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('app/debits/List'),
          meta: {
            title: 'Adeudos'
          }
        },
        {
          path: ':debitId',
          component: lazyLoading('app/debits/View'),
          props: true,
          meta: {
            title: 'Adeudo'
          },
        },
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/test.js